// src/components/Employee/EmployeeModal.jsx
import React, { useState, useEffect } from 'react';
import './employee.css';

const EmployeeModal = ({ isOpen, onClose, onSave, isSaving, departments = [], designations = [] }) => {
  const [formData, setFormData] = useState({
    employeeCode: '',
    title: '',
    firstName: '',
    middleName: '',
    lastName: '',
    nic: '',
    passportNumber: '',
    drivingLicense: '',
    dateOfBirth: '',
    gender: '',
    maritalStatus: '',
    nationality: '',
    personalEmail: '',
    workEmail: '',
    contactNumber: '',
    emergencyContact: '',
    emergencyContactRelationship: '',
    address: '',
    city: '',
    country: '',
    dateJoined: '',
    dateConfirmed: '',
    employmentType: '',
    employmentStatus: 'ACTIVE',
    departmentId: '',
    designationId: '',
    basicSalary: '',
    bankName: '',
    bankBranch: '',
    accountNumber: '',
    accountName: '',
    isActive: true,
  });

  useEffect(() => {
    console.log('Departments:', departments);
    console.log('Designations:', designations);
  }, [departments, designations]);

  useEffect(() => {
    if (isOpen) {
      setFormData({
        employeeCode: '',
        title: '',
        firstName: '',
        middleName: '',
        lastName: '',
        nic: '',
        passportNumber: '',
        drivingLicense: '',
        dateOfBirth: '',
        gender: '',
        maritalStatus: '',
        nationality: '',
        personalEmail: '',
        workEmail: '',
        contactNumber: '',
        emergencyContact: '',
        emergencyContactRelationship: '',
        address: '',
        city: '',
        country: '',
        dateJoined: '',
        dateConfirmed: '',
        employmentType: '',
        employmentStatus: 'ACTIVE',
        departmentId: '',
        designationId: '',
        basicSalary: '',
        bankName: '',
        bankBranch: '',
        accountNumber: '',
        accountName: '',
        isActive: true,
      });
    }
  }, [isOpen]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  // Auto-generate fullName
  const generatedFullName = [
    formData.firstName,
    formData.middleName,
    formData.lastName
  ]
    .filter(name => name && name.trim())
    .join(' ')
    .trim();

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.employeeCode || !formData.firstName || !formData.lastName || !formData.nic || 
        !formData.contactNumber || !formData.departmentId || !formData.designationId || !formData.basicSalary) {
      alert('Please fill all required fields');
      return;
    }

    const payload = {
      employeeCode: formData.employeeCode,
      title: formData.title,
      firstName: formData.firstName,
      middleName: formData.middleName,
      lastName: formData.lastName,
      fullName: generatedFullName,
      nic: formData.nic,
      passportNumber: formData.passportNumber,
      drivingLicense: formData.drivingLicense,
      dateOfBirth: formData.dateOfBirth,
      gender: formData.gender,
      maritalStatus: formData.maritalStatus,
      nationality: formData.nationality,
      personalEmail: formData.personalEmail,
      workEmail: formData.workEmail,
      contactNumber: formData.contactNumber,
      emergencyContact: formData.emergencyContact,
      emergencyContactRelationship: formData.emergencyContactRelationship,
      address: formData.address,
      city: formData.city,
      country: formData.country,
      dateJoined: formData.dateJoined,
      dateConfirmed: formData.dateConfirmed,
      employmentType: formData.employmentType,
      employmentStatus: formData.employmentStatus,
      departmentId: parseInt(formData.departmentId),
      designationId: parseInt(formData.designationId),
      basicSalary: parseFloat(formData.basicSalary),
      bankName: formData.bankName,
      bankBranch: formData.bankBranch,
      accountNumber: formData.accountNumber,
      accountName: formData.accountName,
      isActive: Boolean(formData.isActive),
    };

    console.log('Generated fullName:', generatedFullName);
    console.log('Final Payload:', payload);
    onSave(payload);
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content" style={{ maxWidth: '800px' }}>
        <header className="modal-header">
          <h3>Add New Employee</h3>
          <button className="close-modal-btn" onClick={onClose} disabled={isSaving}>
            ×
          </button>
        </header>
        <div className="modal-body" style={{ maxHeight: '70vh', overflowY: 'auto' }}>
          <form id="employeeForm" onSubmit={handleSubmit}>
            <div className="form-grid-modal">
              
              <label>Employee Code *</label>
              <input name="employeeCode" className="custom-input" value={formData.employeeCode} onChange={handleChange} required disabled={isSaving} placeholder="EMP24001" />

              <label>Title</label>
              <select name="title" className="custom-select" value={formData.title} onChange={handleChange} disabled={isSaving}>
                <option value="">Select Title</option>
                <option value="Mr.">Mr.</option>
                <option value="Mrs.">Mrs.</option>
                <option value="Ms.">Ms.</option>
                <option value="Dr.">Dr.</option>
              </select>

              <label>First Name *</label>
              <input name="firstName" className="custom-input" value={formData.firstName} onChange={handleChange} required disabled={isSaving} />

              <label>Middle Name</label>
              <input name="middleName" className="custom-input" value={formData.middleName} onChange={handleChange} disabled={isSaving} />

              <label>Last Name *</label>
              <input name="lastName" className="custom-input" value={formData.lastName} onChange={handleChange} required disabled={isSaving} />

              {/* ✅ Auto-generated Full Name Display */}
              <label style={{ fontWeight: 'bold', color: '#27ae60' }}>Full Name (Auto-generated)</label>
              <div 
                style={{
                  padding: '10px',
                  backgroundColor: '#d5f4e6',
                  border: '2px solid #27ae60',
                  borderRadius: '4px',
                  fontWeight: 'bold',
                  color: '#27ae60',
                  minHeight: '40px',
                  display: 'flex',
                  alignItems: 'center'
                }}
              >
                {generatedFullName || '(Enter first and last name)'}
              </div>

              <label>NIC *</label>
              <input name="nic" className="custom-input" value={formData.nic} onChange={handleChange} required disabled={isSaving} placeholder="199512345678" />

              <label>Passport Number</label>
              <input name="passportNumber" className="custom-input" value={formData.passportNumber} onChange={handleChange} disabled={isSaving} />

              <label>Driving License</label>
              <input name="drivingLicense" className="custom-input" value={formData.drivingLicense} onChange={handleChange} disabled={isSaving} />

              <label>Date of Birth</label>
              <input name="dateOfBirth" type="date" className="custom-input" value={formData.dateOfBirth} onChange={handleChange} disabled={isSaving} />

              <label>Gender</label>
              <select name="gender" className="custom-select" value={formData.gender} onChange={handleChange} disabled={isSaving}>
                <option value="">Select Gender</option>
                <option value="MALE">Male</option>
                <option value="FEMALE">Female</option>
                <option value="OTHER">Other</option>
              </select>

              <label>Marital Status</label>
              <select name="maritalStatus" className="custom-select" value={formData.maritalStatus} onChange={handleChange} disabled={isSaving}>
                <option value="">Select Status</option>
                <option value="SINGLE">Single</option>
                <option value="MARRIED">Married</option>
                <option value="DIVORCED">Divorced</option>
                <option value="WIDOWED">Widowed</option>
              </select>

              <label>Nationality</label>
              <input name="nationality" className="custom-input" value={formData.nationality} onChange={handleChange} disabled={isSaving} placeholder="Sri Lankan" />

              <label>Contact Number *</label>
              <input name="contactNumber" className="custom-input" value={formData.contactNumber} onChange={handleChange} required disabled={isSaving} placeholder="0712345678" />

              <label>Personal Email</label>
              <input name="personalEmail" type="email" className="custom-input" value={formData.personalEmail} onChange={handleChange} disabled={isSaving} />

              <label>Work Email</label>
              <input name="workEmail" type="email" className="custom-input" value={formData.workEmail} onChange={handleChange} disabled={isSaving} />

              <label>Emergency Contact</label>
              <input name="emergencyContact" className="custom-input" value={formData.emergencyContact} onChange={handleChange} disabled={isSaving} />

              <label>Emergency Relationship</label>
              <input name="emergencyContactRelationship" className="custom-input" value={formData.emergencyContactRelationship} onChange={handleChange} disabled={isSaving} placeholder="Spouse" />

              <label>Address</label>
              <input name="address" className="custom-input" value={formData.address} onChange={handleChange} disabled={isSaving} />

              <label>City</label>
              <input name="city" className="custom-input" value={formData.city} onChange={handleChange} disabled={isSaving} />

              <label>Country</label>
              <input name="country" className="custom-input" value={formData.country} onChange={handleChange} disabled={isSaving} placeholder="Sri Lanka" />

              <label>Date Joined</label>
              <input name="dateJoined" type="date" className="custom-input" value={formData.dateJoined} onChange={handleChange} disabled={isSaving} />

              <label>Date Confirmed</label>
              <input name="dateConfirmed" type="date" className="custom-input" value={formData.dateConfirmed} onChange={handleChange} disabled={isSaving} />

              <label>Employment Type</label>
              <select name="employmentType" className="custom-select" value={formData.employmentType} onChange={handleChange} disabled={isSaving}>
                <option value="">Select Type</option>
                <option value="PERMANENT">Permanent</option>
                <option value="CONTRACT">Contract</option>
                <option value="INTERN">Intern</option>
                <option value="TEMPORARY">Temporary</option>
              </select>

              <label>Employment Status</label>
              <select name="employmentStatus" className="custom-select" value={formData.employmentStatus} onChange={handleChange} disabled={isSaving}>
                <option value="ACTIVE">Active</option>
                <option value="INACTIVE">Inactive</option>
                <option value="TERMINATED">Terminated</option>
                <option value="RESIGNED">Resigned</option>
              </select>

              <label>Department *</label>
              <select name="departmentId" className="custom-select" value={formData.departmentId} onChange={handleChange} required disabled={isSaving}>
                <option value="">Select Department</option>
                {departments && departments.length > 0 ? (
                  departments.map((dept) => (
                    <option key={dept.id} value={dept.id}>
                      {dept.name}
                    </option>
                  ))
                ) : (
                  <option disabled>No departments available</option>
                )}
              </select>

              <label>Designation *</label>
              <select name="designationId" className="custom-select" value={formData.designationId} onChange={handleChange} required disabled={isSaving}>
                <option value="">Select Designation</option>
                {designations && designations.length > 0 ? (
                  designations.map((desig) => (
                    <option key={desig.id} value={desig.id}>
                      {desig.name}
                    </option>
                  ))
                ) : (
                  <option disabled>No designations available</option>
                )}
              </select>

              <label>Basic Salary *</label>
              <input name="basicSalary" type="number" step="0.01" className="custom-input" value={formData.basicSalary} onChange={handleChange} required disabled={isSaving} placeholder="85000" />

              <label>Bank Name</label>
              <input name="bankName" className="custom-input" value={formData.bankName} onChange={handleChange} disabled={isSaving} />

              <label>Bank Branch</label>
              <input name="bankBranch" className="custom-input" value={formData.bankBranch} onChange={handleChange} disabled={isSaving} />

              <label>Account Number</label>
              <input name="accountNumber" className="custom-input" value={formData.accountNumber} onChange={handleChange} disabled={isSaving} />

              <label>Account Name</label>
              <input name="accountName" className="custom-input" value={formData.accountName} onChange={handleChange} disabled={isSaving} />

              <label>Active</label>
              <input type="checkbox" name="isActive" checked={formData.isActive} onChange={handleChange} disabled={isSaving} />
            </div>
          </form>
        </div>
        <footer className="modal-footer">
          <button className="btn btn-cancel" onClick={onClose} disabled={isSaving}>
            Cancel
          </button>
          <button className="btn btn-save" type="submit" form="employeeForm" disabled={isSaving}>
            {isSaving ? 'Saving...' : 'Save Employee'}
          </button>
        </footer>
      </div>
    </div>
  );
};

export default EmployeeModal;